import * as API from 'src/helpers/api_helper'
import * as URL from 'src/helpers/url_helper'

export const HowToDocumentCategoryListApi = (data) =>
    API.get(`${URL.GET_ALL_HOW_TO_DOCUMENT_CATEGORY_LIST}`, data.params)
export const HowToDocumentCategoryCreateApi = (data) =>
    API.post(`${URL.CREATE_HOW_TO_DOCUMENT_CATEGORY}`, data.body)
export const HowToDocumentCategoryGetOneApi = (data) =>
    API.get(`${URL.GET_ONE_HOW_TO_DOCUMENT_CATEGORY}/${data.ID}`)
export const HowToDocumentCategoryUpdateApi = (data) =>
    API.patch(`${URL.UPDATE_HOW_TO_DOCUMENT_CATEGORY}/${data?.ID}`, data.body)
export const HowToDocumentCategoryDeleteApi = (data) =>
    API.del(`${URL.DELETE_HOW_TO_DOCUMENT_CATEGORY}/${data.ID}`)
export const HowToDocumentCategoryPublishApi = (data) =>
    API.patch(`${URL.PUBLISH_HOW_TO_DOCUMENT_CATEGORY}`, data)

//
export const HowToDocumentSubCategoryListApi = (data) =>
    API.get(`${URL.GET_ALL_HOW_TO_DOCUMENT_SUB_CATEGORY_LIST}`, data.params)
export const HowToDocumentSubCategoryCreateApi = (data) =>
    API.post(`${URL.CREATE_HOW_TO_DOCUMENT_SUB_CATEGORY}`, data.body, {
        params: data.params
    })
export const HowToDocumentSubCategoryGetOneApi = (data) =>
    API.get(`${URL.GET_ONE_HOW_TO_DOCUMENT_SUB_CATEGORY}/${data.ID}`)
export const HowToDocumentSubCategoryUpdateApi = (data) =>
    API.patch(`${URL.UPDATE_HOW_TO_DOCUMENT_SUB_CATEGORY}/${data?.ID}`, data.body)
export const HowToDocumentSubCategoryDeleteApi = (data) =>
    API.del(`${URL.DELETE_HOW_TO_DOCUMENT_SUB_CATEGORY}/${data?.ID}`)
export const HowToDocumentSubCategoryPublishApi = (data) =>
    API.patch(`${URL.PUBLISH_HOW_TO_DOCUMENT_SUB_CATEGORY}`, data)

////
export const DocumentListApi = (data) => API.get(`${URL.GET_ALL_HOW_TO_DOCUMENT_LIST}`, data.params)
export const DocumentCreateApi = (data) =>
    API.post(`${URL.CREATE_HOW_TO_DOCUMENT}`, data.body, {
        params: data.params
    })
export const DocumentUpdateApi = (data) =>
    API.patch(`${URL.UPDATE_HOW_TO_DOCUMENT}/${data?.ID}`, data.body)
export const DocumentDeleteApi = (data) => API.del(`${URL.DELETE_HOW_TO_DOCUMENT}/${data.ID}`)
